export const BRAND_VOICE_GENERATION_TYPE = {
  targetAudiences: 'target_audiences',
  toneOfVoices: 'tone_of_voices',
  formula: 'formula',
  brandRules: 'brand_rules',
  customModel: 'custom_model',
};

export const BRAND_VOICE_GENERATION_TYPE_LABEL = {
  [BRAND_VOICE_GENERATION_TYPE.targetAudiences]: 'Target audiences',
  [BRAND_VOICE_GENERATION_TYPE.toneOfVoices]: 'Tone of voices',
  [BRAND_VOICE_GENERATION_TYPE.formula]: 'Formulas',
  [BRAND_VOICE_GENERATION_TYPE.brandRules]: 'Brand rules',
  [BRAND_VOICE_GENERATION_TYPE.customModel]: 'Custom models',
};

export const BACKEND_BRAND_VOICE_GENERATION_KEY = {
  [BRAND_VOICE_GENERATION_TYPE.targetAudiences]: 'generation_target_audiences',
  [BRAND_VOICE_GENERATION_TYPE.toneOfVoices]: 'generation_tone_of_voices_and_brand_rules',
  [BRAND_VOICE_GENERATION_TYPE.formula]: 'generation_formula',
  [BRAND_VOICE_GENERATION_TYPE.brandRules]: 'generation_tone_of_voices_and_brand_rules',
  [BRAND_VOICE_GENERATION_TYPE.customModel]: 'generation_custom_model',
};

export const FRONTEND_BRAND_VOICE_GENERATION_TYPES = {
  generation_tone_of_voices_and_brand_rules: [
    BRAND_VOICE_GENERATION_TYPE.brandRules,
    BRAND_VOICE_GENERATION_TYPE.toneOfVoices,
  ],
};
